import React from "react";
import { Modal } from "react-bootstrap";

const InfoPopup1 = ({ infoData1, drugInt, show, onHide }) => {
    console.log("hi")
    const medicationName = infoData1?.med_name
        ? infoData1.med_name.charAt(0).toUpperCase() + infoData1.med_name.slice(1).toLowerCase()
        : 'Medication Information';

    // Helper function to safely format strings
    const formatText = (text) => {
        if (!text) return '';
        return text.toString().replace(/_/g, ' ').replace(/-/g, ' ');
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="medication-info-modal"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title id="medication-info-modal">
                    {medicationName}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>{drugInt ?
                <div style={{ textAlign: "left", border: "2px solid #e4dd9f5c", }}>
                    <div style={{ paddingLeft: "2%" }} className="row ">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Drug interactions</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1.med_interactions}</div></div>
                    </div>
                    <div style={{ paddingLeft: "2%" }} className="row">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>URL</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1.med_url}</div></div>
                    </div>

                </div>
                :
                <div style={{ textAlign: "left", border: "2px solid #e4dd9f5c", }}>
                    <div style={{ paddingLeft: "2%" }} className="row ">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Composition</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1?.composition}</div></div>
                    </div>
                    <div style={{ paddingLeft: "2%" }} className="row">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Strength</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1?.strength}{infoData1?.strength_unit}</div></div>
                    </div>
                    <div style={{ paddingLeft: "2%" }} className="row">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4">
                            <div style={{ paddingTop: "2%", paddingBottom: "2%", }}>
                                {(infoData1?.healthcare_type === "Unani" || infoData1?.category || infoData1?.unani_category)
                                    ? 'Category'
                                    : 'Dosage form'}
                            </div>
                        </div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8">
                            <div style={{ paddingTop: "2%", paddingBottom: "2%", }}>
                                {(() => {
                                    const isUnani = infoData1?.healthcare_type === "Unani" || infoData1?.category || infoData1?.unani_category;

                                    if (isUnani) {
                                        const catValue = infoData1?.category || infoData1?.unani_category;
                                        return catValue ? catValue.replace(/_/g, ' ') : "";
                                    } else {
                                        return infoData1?.dosage_form?.replace(/_/g, ' ');
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                    <div style={{ paddingLeft: "2%" }} className="row">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Medicine type</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1?.med_type?.replace(/_/g, ' ')}</div></div>
                    </div>
                    <div style={{ paddingLeft: "2%" }} className="row">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Route of medicine</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1.route ? infoData1?.route?.replace(/_/g, ' ').replace(/-/g, ' ') : ""}</div></div>
                    </div>
                    <div style={{ paddingLeft: "2%" }} className="row">
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Description</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1?.description}</div></div>
                    </div>
                    <div className="row" style={{ paddingLeft: "2%" }}>
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Manufacturer name</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1?.manufacturer_name}</div></div>
                    </div>
                    <div className="row" style={{ paddingLeft: "2%" }}>
                        <div style={{ backgroundColor: "#e4dd9f5c", border: "2px solid white", borderRadius: "5px", }} className="col-4"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}>Manufacturer address</div></div>
                        <div style={{ border: "2px solid white", borderRadius: "5px", }} className="col-8"><div style={{ paddingTop: "2%", paddingBottom: "2%", }}> {infoData1?.manufacturer_address}</div></div>
                    </div>
                </div>}
            </Modal.Body>
        </Modal>
    );
};

// Add CSS (either in a separate file or styled-components)
// .info-container {
//     text-align: left;
//     border: 2px solid #e4dd9f5c;
// }
// 
// .info-row {
//     display: flex;
//     padding: 0 2%;
//     margin-bottom: 5px;
// }
// 
// .info-label {
//     flex: 0 0 30%;
//     background-color: #e4dd9f5c;
//     padding: 8px 12px;
//     border-radius: 5px;
//     margin-right: 5px;
// }
// 
// .info-value {
//     flex: 1;
//     padding: 8px 12px;
//     border-radius: 5px;
//     background-color: #f8f9fa;
// }

export default InfoPopup1;